import cn from 'classnames';
import type { MessageDirection } from '../../../../types';

const URL_REGEX = /(?<url>https?:\/\/\S*[^.,!?:;)\]}'"\s]|www\.\S*[^.,!?:;)\]}'"\s])/i;
const toHref = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

type P = {
  direction: MessageDirection;
  text: string;
};

const ChatMessageBubbleTextWithLinks = ({ direction, text }: P) =>
  text.split(URL_REGEX).map((part) =>
    URL_REGEX.test(part) ? (
      <a
        className={cn('chat-message-bubble-text-with-links__link', {
          'chat-message-bubble-text-with-links__link--incoming': direction === 'incoming',
          'chat-message-bubble-text-with-links__link--outgoing': direction === 'outgoing',
        })}
        href={toHref(part)}
        key={part}
        rel="noopener noreferrer"
        target="_blank"
      >
        {part}
      </a>
    ) : (
      part
    ),
  );

export default ChatMessageBubbleTextWithLinks;
